export default [
    {
        title: 'Home',
        route: 'home',
        icon: 'HomeIcon',
    },
    {
        title: 'Base centralizada',
        icon: 'DatabaseIcon',
        children: [
            {
                title: "Agendamentos",
                route: 'list-agendamentos',
            },
            {
                title: "Atendimentos",
                route: 'list-atendimentos',
            },
            {
                title: "Botões",
                route: 'list-botoes',
            },
            {
                title: "CBO's",
                route: 'list-cbos',
            },
            {
                title: "Classificações",
                route: 'list-classificacoes',
            },
            {
                title: "Finalizações",
                route: 'list-finalizacoes',
            },
            {
                title: "Locais",
                route: 'list-locais',
            },
            {
                title: "Paineis",
                route: 'list-paineis',
            },
            {
                title: "Pessoas",
                route: 'list-pessoas',
            },
            {
                title: "Setores",
                route: 'list-setores',
            },
            {
                title: "Totens",
                route: 'list-totens',
            },
            {
                title: "Usuários do SIGAP",
                route: 'list-usuarios',
            },
        ],
    },
    {
        title: 'Cadastros',
        icon: 'PlusIcon',
        children: [
            {
                title: 'Usuários',
                route: 'list-users',
            },
            {
                title: 'Unidades',
                route: 'list-unidades',
            },
            {
                title: 'Grupos',
                route: 'list-grupos',
            },
            {
                title: 'Videos',
                route: 'list-videos',
            },
            {
                title: 'Manuais',
                route: 'list-manuais',
            },
            {
                title: 'Grupos de Manuais',
                route: 'list-manual-grupos',
            },
        ],
    },
    {
        title: 'Relatórios',
        icon: 'PieChartIcon',
        children: [],
    },
]
